import { IS_MODERN_SSR } from './constants.tsx';

export function getIsModernSsr() {
	return IS_MODERN_SSR;
}
